import { ACES_PAGE } from '@/lib/aces-data';
import { cn } from '@/lib/utils';
import { Layers, RefreshCw, ShieldCheck, Sparkles } from 'lucide-react';

const CONCEPT_CARDS = [
  {
    icon: ShieldCheck,
    title: 'Assinatura',
    description: 'Ativo na sua conta xat durante o período subscrito na loja.',
    accent: 'from-amber-500/15 to-amber-600/5 border-amber-200/60',
    iconClass: 'text-amber-600 bg-amber-50',
  },
  {
    icon: RefreshCw,
    title: 'Renovação',
    description: 'Renovação opcional a cada 30 dias; renovação automática disponível.',
    accent: 'from-sky-500/15 to-sky-600/5 border-sky-200/60',
    iconClass: 'text-sky-600 bg-sky-50',
  },
  {
    icon: Layers,
    title: 'Níveis',
    description: 'Em alguns Aces, renovações automáticas concedem descontos por nível.',
    accent: 'from-violet-500/15 to-violet-600/5 border-violet-200/60',
    iconClass: 'text-violet-600 bg-violet-50',
  },
  {
    icon: Sparkles,
    title: 'Benefícios',
    description: 'Smilie exclusivo e funcionalidades únicas para assinantes.',
    accent: 'from-indigo-500/15 to-indigo-600/5 border-indigo-200/60',
    iconClass: 'text-indigo-600 bg-indigo-50',
  },
] as const;

export function AcesWhatSection() {
  return (
    <section className="border-b border-gray-100 bg-white py-16 md:py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:gap-16">
        <div>
          <span className="mb-4 inline-flex rounded-full border border-amber-200 bg-amber-50 px-3 py-1 font-poppins text-[11px] font-semibold uppercase tracking-wide text-amber-800">
            Conceito
          </span>
          <h2 className="font-poppins text-2xl font-bold text-gray-900 md:text-3xl">
            {ACES_PAGE.whatTitle}
          </h2>
          <p className="mt-4 font-inter text-base leading-relaxed text-gray-600">
            {ACES_PAGE.whatText}
          </p>
          <p className="mt-4 font-inter text-base leading-relaxed text-gray-600">
            {ACES_PAGE.whatTextExtra}
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {CONCEPT_CARDS.map((card) => {
            const Icon = card.icon;
            return (
              <div
                key={card.title}
                className={cn(
                  'rounded-2xl border bg-gradient-to-br p-5 transition-all duration-300',
                  'hover:-translate-y-0.5 hover:shadow-md',
                  card.accent
                )}
              >
                <div
                  className={cn(
                    'mb-3 flex h-10 w-10 items-center justify-center rounded-xl',
                    card.iconClass
                  )}
                >
                  <Icon className="h-5 w-5" strokeWidth={2} />
                </div>
                <h3 className="font-poppins text-base font-semibold text-gray-900">{card.title}</h3>
                <p className="mt-2 font-inter text-sm leading-relaxed text-gray-600">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
